import React from 'react'
import SearchForm from './SearchForm'

const Search = () => {
    return (
        <div className='login min-h-screen 2xl:p-40 2xl:px-96 xl:p-40 flex justify-center items-center'>
            <SearchForm/>
        </div>
    )
}

export default Search